interface StKilianSalesFormData {
  name: string;
  email: string;
  photos: File[];
  bottlingYear: number;
  alcoholContent: number;
  bottleSize: string;
  numberOfBottles: number;
  caskType: string;
  caskNumber?: string;
  bottlingName?: string;
  additionalDetails?: string;
}

interface StKilianSalesFormResponse {
  success: boolean;
  data: {
    id: string;
    status: string;
    submittedAt: string;
    message: string;
  };
  message: string;
}

export default async function doSubmitStKilianSalesForm(
  formData: StKilianSalesFormData
): Promise<StKilianSalesFormResponse> {
  const submitData = new FormData();
  submitData.append('name', formData.name);
  submitData.append('email', formData.email);
  submitData.append('bottlingYear', formData.bottlingYear.toString());
  submitData.append('alcoholContent', formData.alcoholContent.toString());
  submitData.append('bottleSize', formData.bottleSize);
  submitData.append('numberOfBottles', formData.numberOfBottles.toString());
  submitData.append('caskType', formData.caskType);
  if (formData.caskNumber) {
    submitData.append('caskNumber', formData.caskNumber);
  }
  if (formData.bottlingName) {
    submitData.append('bottlingName', formData.bottlingName);
  }
  if (formData.additionalDetails) {
    submitData.append('additionalDetails', formData.additionalDetails);
  }
  formData.photos.forEach((photo, index) => {
    submitData.append('photos', photo);
  });
  const response = await fetch('/api/st-kilian/sales-form', {
    method: 'POST',
    body: submitData,
    // Don't set Content-Type header - let the browser set it with boundary for FormData
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to submit form');
  }
  const result = await response.json();
  return result;
}
